import React, { useEffect } from "react";
import { Switch, Route, useRouteMatch, useHistory } from "react-router-dom";
import { StyledText } from "../components/common/basic";
import { Desktop } from "../containers/common";

// hooks
import { useAuth } from "../hooks/";
import SubscriberHome from "../screens/subscriber/home";
import { ProfileScreen } from "../screens/subscriber/profile";

const Home = ({ location }) => {
  const { checkAuth } = useAuth();

  const match = useRouteMatch();

  const history = useHistory();

  useEffect(() => {
    const { search } = location;

    const queryParams = new URLSearchParams(search);

    const token = queryParams.get("token");

    const gps = queryParams.get("gps");

    if (!token) {
      history.push("/error");
    } else {
      checkAuth(token, gps);
    }
  }, []);

  return (
    <Desktop phonebg={"white"}>
      <Switch>
        <Route
          path={`${match.path}/profile`}
          render={() => <ProfileScreen />}
        />
        <Route path={`${match.path}`} render={() => <SubscriberHome />} />
      </Switch>
    </Desktop>
  );
};

export default Home;
